import React from 'react';
import { useQueryClient, useMutation } from '@tanstack/react-query';

import { FeedbackContext } from '@cvt/contexts';

import { cacheKeys } from '../config';
import { programClient } from '../client/programClient';


export const useEnrollmentCrud = () => {
  const { genericErrorFeedback } = React.useContext(FeedbackContext);
  const queryClient = useQueryClient();

  const createEnrollment = useMutation({
    mutationKey: [cacheKeys.createEnrollment],
    mutationFn: programClient.createEnrollment,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getEnrollments],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    createEnrollment,
  };
};
